  (() => {
    const root = document.querySelector('[data-sm-ebook]'); if (!root || root.dataset.ready) return; root.dataset.ready = 'true';
    const stage = root.querySelector('[data-gallery-stage]');
    const galleryButtons = [...root.querySelectorAll('[data-gallery-button]')];
    const galleryViews = [...root.querySelectorAll('[data-gallery-view]')];
    const galleryOrder = galleryButtons.map(button => button.dataset.galleryButton);
    const activateGalleryView = view => {
      galleryButtons.forEach(button => button.classList.toggle('is-active', button.dataset.galleryButton === view));
      galleryViews.forEach(el => el.classList.toggle('is-active', el.dataset.galleryView === view));
    };
    const moveGallery = direction => {
      const activeView = root.querySelector('[data-gallery-view].is-active')?.dataset.galleryView;
      const activeIndex = Math.max(0, galleryOrder.indexOf(activeView));
      const nextIndex = (activeIndex + direction + galleryOrder.length) % galleryOrder.length;
      activateGalleryView(galleryOrder[nextIndex]);
    };

    galleryButtons.forEach(button => button.addEventListener('click', () => activateGalleryView(button.dataset.galleryButton)));

    if (stage && galleryOrder.length > 1) {
      stage.style.touchAction = 'pan-y';
      let pointerStartX = 0;
      let pointerStartY = 0;

      stage.addEventListener('pointerdown', event => {
        if (!event.isPrimary) return;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        stage.classList.add('is-swiping');
        stage.setPointerCapture?.(event.pointerId);
      });

      stage.addEventListener('pointerup', event => {
        if (!event.isPrimary) return;
        const deltaX = event.clientX - pointerStartX;
        const deltaY = event.clientY - pointerStartY;
        stage.classList.remove('is-swiping');
        if (Math.abs(deltaX) >= 45 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15) {
          moveGallery(deltaX < 0 ? 1 : -1);
        }
      });

      stage.addEventListener('pointercancel', () => stage.classList.remove('is-swiping'));
      stage.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          moveGallery(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
    }
    const qty = root.querySelector('input[name="quantity"]');
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => qty.value = Math.max(1, Number(qty.value || 1) - 1));
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => qty.value = Number(qty.value || 1) + 1);
    root.querySelector('[data-scroll-top]')?.addEventListener('click', () => root.querySelector('.sm-product-info').scrollIntoView({behavior:'smooth', block:'center'}));
    root.querySelectorAll('.sm-store-button').forEach(button => {
      button.addEventListener('pointermove', event => { if (matchMedia('(pointer:coarse)').matches) return; const b = button.getBoundingClientRect(); button.style.setProperty('--x', `${((event.clientX-b.left)/b.width-.5)*10}px`); button.style.setProperty('--y', `${((event.clientY-b.top)/b.height-.5)*10}px`); });
      button.addEventListener('pointerleave', () => { button.style.setProperty('--x','0px'); button.style.setProperty('--y','0px'); });
    });
  })();
